module.exports = __webpack_public_path__ + "static/media/os-min.73c0d656.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/os-min.svg
// module id = 683
// module chunks = 0